export default "__VITE_ASSET__3mnY5LrA__"